import React, { useState, useEffect, useMemo } from "react";
import { Accordion } from "react-bootstrap";
import "./OpalAccordionItem.css";
import { getAll } from "../../localDB";
import OpalCardFactory from "../OpalCardFactory/OpalCardFactory";
import TauriImage from "../TauriImage/TauriImage";
import { SyncStatusMap } from "../../visualizations/visualizations";

const OpalAccordionItem = ({
    items,
    search,
    onSelectItem,
    type,
    selectedCard,
    setSelectedCard,
    groupby,
    onDeleteItem,
    onLongPress,
    onDoubleClick }) => {

    const [institutions, setInstitutions] = useState([]);

    useEffect(() => {
        const fetchInstitutions = async () => {
            try {
                const data = await getAll("institution");
                const filtered = data.filter(item => item.SyncStatus !== SyncStatusMap.done);
                setInstitutions(filtered);
            } catch (error) {
                console.error("Failed to fetch", error);
            }
        };

        fetchInstitutions();
    }, []);

    const institutionMap = useMemo(() => {
        const map = {};
        institutions.forEach(inst => {
            map[inst.ID] = inst.Name;
        });
        return map;
    }, [institutions]);

    const getInstitutionName = (id) => institutionMap[id];

    function getValueByKey(obj, key) {
        return obj?.[key];
    }

    const groupedItem = useMemo(() => {
        return items.reduce((acc, item) => {
            const customer = item.Customer;
            const groupValue = getValueByKey(customer, groupby) ?? 'Ungrouped';

            if (!acc[groupValue]) {
                acc[groupValue] = {
                    key: groupValue,
                    code: customer?.Code,
                    items: []
                };
            }

            acc[groupValue].items.push(item);
            return acc;
        }, {});
    }, [items, institutionMap, groupby]);



    useEffect(() => {
        const keys = Object.keys(groupedItem).map((_, index) => index.toString());
        setActiveKeys(keys);
    }, [items, institutionMap]);

    const [activeKeys, setActiveKeys] = useState(null);

    const handleAccordionClick = (eventKey) => {
        setActiveKeys((prevKeys) =>
            prevKeys.includes(eventKey)
                ? prevKeys.filter((key) => key !== eventKey) // Close if already open
                : [...prevKeys, eventKey] // Open if closed
        );
    };

    const toProperCase = (text) =>
        text?.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

    return (
        <div className="opal-accordion-item px-2 pt-2">
            {groupby && groupedItem ? (
                <Accordion activeKey={activeKeys} alwaysOpen>
                    {Object.entries(groupedItem).map(([key, data], index) => (
                        <Accordion.Item eventKey={index.toString()} key={key}>
                            {(type === "v2" || type === "v3" || type === "v6") ? (
                                <Accordion.Header className="v2 p-0 mb-2" onClick={() => handleAccordionClick(index.toString())}>
                                    <div className="d-flex align-items-center w-100">
                                        <div className="count-column d-flex align-items-center me-2">
                                            <TauriImage
                                                localImage="/Images/carbon--settings.svg"
                                                alt="icon"
                                                className="me-1"
                                                color={"#EEB053"}
                                            />
                                            <span className="group-count">{data.items?.length ?? 0}</span>
                                        </div>
                                        <div className="d-flex flex-column text-start">
                                            <span className="acc-header">{toProperCase(data.key?.toString() ?? 'Ungrouped')}</span>
                                            {/* <span className="acc-subheader">{toProperCase(data.key?.toString() ?? 'Ungrouped')}</span> */}
                                        </div>
                                    </div>
                                </Accordion.Header>
                            ) : (
                                <Accordion.Header className="v1 p-0 mb-2" onClick={() => handleAccordionClick(index.toString())}>
                                    <div className="d-flex flex-column py-1">
                                        <span className="acc-subheader mb-1">{toProperCase(data.key?.toString() ?? 'Ungrouped')}</span>
                                    </div>
                                </Accordion.Header>
                            )}
                            <Accordion.Body className="py-0 px-0">
                                {Array.isArray(data.items) &&
                                    data.items.map((item) =>
                                        OpalCardFactory(type, {
                                            item,
                                            selectedCard,
                                            setSelectedCard,
                                            search,
                                            onSelectItem,
                                            onDeleteItem,
                                            onLongPress,
                                            onDoubleClick
                                        })
                                    )}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            ) : (
                items.map((item) =>
                    OpalCardFactory(type, {
                        item,
                        selectedCard,
                        setSelectedCard,
                        search,
                        onSelectItem,
                        onDeleteItem,
                        onLongPress,
                        onDoubleClick
                    })
                )
            )}
        </div>

    );
};

export default OpalAccordionItem;
